import { Button, Flex, OptimizeImage, Text, Title } from '@inflearn/ds-react';
import { Trans, useTranslation } from 'next-i18next';

import { NEXT_PUBLIC_CDN_INTEGRATED_HOST } from '../../../../appConfig';
import { useIsWebview } from '../../../hooks/useIsWebview';
import { useReferUrlNavigation } from '../../../hooks/useReferUrlNavigation';

export const CompleteSignup = () => {
  const { t } = useTranslation();
  const { getReferUrl } = useReferUrlNavigation();
  const isWebview = useIsWebview();

  return (
    <Flex direction="column">
      <Flex direction="column" justify="center" align="center" gap={12} mb={32}>
        <Title order={2} align="center">
          {t('인증 메일을 보내드렸어요.')}
        </Title>
        <OptimizeImage
          width="120"
          height="120"
          alt={t('메일')}
          src={`${NEXT_PUBLIC_CDN_INTEGRATED_HOST}/image/apng/love-letter.png`}
        />

        <Text size="md" align="center">
          {t('메일함을 확인해 주세요.')}

          <br />
          <Trans
            i18nKey={
              '가입하신 이메일을 인증해 주시면, 인프런의 서비스를 마음껏 이용하실 수 있어요.'
            }
            components={{ br: <br /> }}
          />
        </Text>
      </Flex>
      {isWebview ? null : (
        <Button component="a" href={getReferUrl()} variant="filled" color="infgreen" size="md">
          {t('이전 페이지로 돌아가기')}
        </Button>
      )}
    </Flex>
  );
};
